import React from 'react';

const NotFound = () => {
    return (
        <div className='m-5 p-5'>
           
            <h2 className='text-center mt-5 mb-3 pb-5 fw-bold'>The URl you entered is not found.please try again</h2>
            <button type="button" class="btn btn-warning fw-bold px-5">back to home</button>
        </div>
    );
};

export default NotFound;